import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { useContent } from "@/i18n/content";
import { useI18n } from "@/i18n";

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] },
  }),
};

export default function Testimonials() {
  const { t } = useI18n();
  const { REVIEWS } = useContent();
  const strip = REVIEWS.slice(0, 3);
  return (
    <section id="testimonials" className="relative bg-[#FBFAF8] py-20 lg:py-24" data-testid="testimonials-strip">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
          <div>
            <span className="font-mono-tech text-xs uppercase tracking-[0.25em] text-emerald-600 font-semibold">
              {t("testi.eyebrow")}
            </span>
            <h2 className="mt-3 font-display font-extrabold tracking-tight text-3xl sm:text-4xl text-[#0B0F14] leading-[1.05]">
              {t("testi.title")}
            </h2>
          </div>
          <div className="flex items-center gap-2.5">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={18} className="fill-amber-400 text-amber-400" />
              ))}
            </div>
            <span className="font-mono-tech text-xs text-slate-500 uppercase tracking-widest">{t("testi.rated")}</span>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {strip.map((r, i) => (
            <motion.div
              key={r.title}
              custom={i}
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-60px" }}
              className="relative bg-white border border-slate-200 rounded-2xl p-7 shadow-soft hover:border-emerald-600/40 hover:-translate-y-1 transition-all duration-300"
              data-testid={`testimonial-card-${i}`}
            >
              <Quote size={30} className="text-emerald-600/25 mb-4" />
              <div className="flex mb-3">
                {[...Array(5)].map((_, j) => (
                  <Star key={j} size={14} className="fill-amber-400 text-amber-400" />
                ))}
              </div>
              <p className="text-slate-600 text-sm leading-relaxed">&ldquo;{r.body}&rdquo;</p>
              <div className="mt-5 pt-4 border-t border-slate-200 flex items-center justify-between">
                <span className="font-display font-semibold text-sm text-[#0B0F14]">{r.author}</span>
                <span className="font-mono-tech text-[11px] uppercase tracking-widest text-emerald-700">{r.city}</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
